import {ref} from 'vue';
import { useRoute, useRouter } from 'vue-router';
import * as planItemApi from "@/api/plans/planitems";
import * as planApi from "@/api/plans/plans";
import {sortPlanItems} from "@/api/plans/planitems";

export function usePlanItem(planid) {
    const planItems = ref([]);
    
    const loadingPlanItems = ref(false);
    const errorPlanItems = ref(null);
    const isSuccessPlanItems = ref(false);
    const messagePlanItemsSuccess = ref('');
    const messagePlanItemsError = ref('');
    const planId = planid;
    
    function setSuccess(msg) {
        messagePlanItemsSuccess.value = msg;
        isSuccessPlanItems.value = true;
    }
    
    function setError(msg) {
        messagePlanItemsError.value = msg;
        isSuccessPlanItems.value = false;
    }
    
    async function loadPlanItems(pageArg = 1, sizeArg = 100) {
        loadingPlanItems.value = true;
        errorPlanItems.value = null;
        try {
            const data = await planItemApi.listPlanItems(planId, pageArg, sizeArg);
            planItems.value = data.content;
        } catch (e) {
            setError('Не удалось загрузить');
        } finally {
            loadingPlanItems.value = false;
        }
    }
    
    async function addPlanItem(payload) {
        try {
            await planItemApi.createPlanItem(planId, payload);
            setSuccess('План элемент добавлен');
        } catch (e) {
            setError("Не удалось сохранить, попробуйте снова");
            if (e?.code === "plan_category_exists") setError("Такая категория уже создана");
            if (e?.code === "plan_big_amount") setError("Сумма категории больше суммы плана");
        }
    }
    
    async function updatePlanItem(id, payload) {
        try {
            await planItemApi.updatePlanItem(planId, id, payload);
            setSuccess('План обновлен');
        } catch (e) {
            setError("Не удалось сохранить, попробуйте снова");
            if (e?.code === "plan_big_amount") setError("Сумма категории больше суммы плана");
        }
    }
    
    async function deletePlanItem(id) {
        try {
            await planItemApi.deletePlanItem(planId, id);
            setSuccess('План удален');
        } catch (e) {
            setError('Не удалось удалить план');
        }
    }
    
    async function sortPlanItems(payload) {
        try {
            await planItemApi.sortPlanItems(planId, payload);
            setSuccess('Сортировка обновлена');
        } catch (e) {
            setError('Не удалось обновить сортировку');
        }
    }
    
    return {
        planItems,
        loadingPlanItems,
        isSuccessPlanItems,
        messagePlanItemsError,
        messagePlanItemsSuccess,
    
        loadPlanItems,
        addPlanItem,
        updatePlanItem,
        sortPlanItems,
        deletePlanItem
    };
}